export default __webpack_public_path__ + "static/media/wrapper-top.77266d29.svg";